import {useMutation} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    CancelDripProgression as CancelDripProgressionMutation,
    CancelDripProgressionVariables,
    DripProgressionDeleteInput,
} from 'nutshell-graphql-types';

import CANCEL_DRIP_PROGRESSION from '../mutations/cancel-drip-progression.graphql';

export const useCancelDripProgression = (): {
    cancelDripProgression: (arg1: DripProgressionDeleteInput) => Promise<any>;
    isLoading: boolean;
    error: string | null | undefined;
} => {
    const [cancelDripProgression, {loading, error}] = useMutation<
        CancelDripProgressionMutation,
        CancelDripProgressionVariables
    >(CANCEL_DRIP_PROGRESSION);

    return {
        cancelDripProgression: (input: DripProgressionDeleteInput) =>
            cancelDripProgression({variables: {input}}),
        isLoading: loading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
    };
};
